export const status = {
  pending: 'PENDING',
  success: 'SUCCESS',
  failure: 'FAILURE'

}